import React, { useRef, useState } from "react";

const NewButton = ({
  id,
  value,
  children,
  addClass,
  style,
  htmlTag,
  iconLeft, // { icon: "@", style: {} }
  iconRight, // { icon: "@", style: {} }
  btnStyle, // styles: flat, default, noStyles
  colStyle, // styles: danger, primary, default, noColor
  toggle,
  url,
  formID,
  onKeyDown,
  onKeyPress,
  onClick,
  history,
  ariaLabel,
  focusableId
}) => {
  const [pressed, setPressed] = useState(true);
  const CustomTag = htmlTag ? htmlTag : "button";
  const button = useRef("button");

  const handleClick = () => {
    if (url) {
      history.push(url);
      return false;
    }
    if (onClick) onClick();
    setPressed(!pressed);
  };

  // generate all css classes
  const generateClasses = () => {
    const btnStyleType =
      {
        noStyles: " ",
        default: "__bd",
        flat: "__bf",
      }[btnStyle] || "__bd";

    const btnColors =
      {
        noColor: " ",
        default: "bc15 c16",
        primary: "bc1 c10",
        danger: "bc4 c10",
      }[colStyle] || "bc15 c16";

    return ["__b __ly_f __ly_f-aic", btnStyleType, addClass, btnColors].join(" ");
  };

  // generate all tag properties
  const generateProperties = () => {
    const props = {
      "data-name": "NewButton",
      "data-test": "NewButton",
      ref: button,
      form: formID,
      tabIndex: "0",
      "data-focusable": focusableId,
      "aria-pressed": toggle && !pressed,
      id: id,
      className: generateClasses(),
      style: style,
      onClick: handleClick,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
    };

    if (ariaLabel) props["aria-label"] = ariaLabel;

    return props;
  };

  return (
    <CustomTag {...generateProperties()}>
      {iconLeft && iconLeft.icon}
      {value || children}
      {iconRight && iconRight.icon}
    </CustomTag>
  );
};

export default NewButton;
